export const SECURITY_EMAIL = 'security@statusmoney.com'
export const SUPPORT_EMAIL = 'support@statusmoney.com'
export const CONTACT_EMAIL = 'contact@statusmoney.com'
export const LEGAL_EMAIL = 'legal@statusmoney.com'
export const PRESS_EMAIL = 'press@statusmoney.com'
